import { types, type Instance } from 'mobx-state-tree';
import Attribute from './attribute';

/**
 * Partial MST model to be composed with models that have attributes (object
 * types, event types, methods).
 */
const AttributeOwner = types
  .model('AttributeOwner', {
    // a list of attributes (see ./attribute.js)
    attributes: types.optional(types.array(Attribute), () => []),
  })
  .views(self => ({
    getAttributeById(id: string) {
      return self.attributes.find(a => a.id === id);
    },
  }))
  .actions(self => ({
    // id? We need a serializable argument to be able to replay
    removeAttribute(id: string) {
      const attribute = self.getAttributeById(id);
      self.attributes.remove(attribute as Instance<typeof Attribute>);
    },
    addAttribute(
      id: string,
      name: string,
      type: string,
      description: string,
      implementation: string,
      validation: string
    ) {
      const attribute = Attribute.create({
        id,
        name,
        type,
        description,
        implementation,
        validation,
      });
      self.attributes.push(attribute);
      return attribute;
    },
  }));

export type IAttributeOwner = Instance<typeof AttributeOwner>;

export default AttributeOwner;
